<template>
  <div>
    <v-layout>
      <v-text-field label="Referans Kodu" @blur="codeControl()" :placeholder="kodmesajı" append-icon="search" :append-icon-cb="dialogac" :tabindex="tabdeger" v-model="val" hide-details=""></v-text-field>

    </v-layout>
    <v-dialog scrollable="" v-model="dialog" max-width="550px">
      <v-card color="grey lighten-2">
        <v-toolbar size="120px" color="info">
          <v-toolbar-title class="white--text"> Referans Listesi</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field solo hide-details autofocus="" ref="ara" v-model="secilendeger" label="En az 3 harf giriniz..." append-icon="search"></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-layout row="" wrap="">
            <div class="flex md12">
              <v-data-table :headers="headersservis" :loading="progress" :items="items" hide-actions class="elevation-1">
                <v-progress-linear slot="progress"  indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <tr @click="kabul(props.item.Kod)" item>
                    <td class="text-xs-left">{{ props.item.Kod }}</td>
                    <td class="text-xs-left">{{ props.item.ReferansAd }}</td>
                    <td class="justify-center layout px-0">
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">
            İptal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
        :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'

  export default {
    props: ["value","tabdeger"],
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },


    beforeMount: beforeMount,
    methods: {
      kayitgetir: kayitgetir,
      dialogac: dialogac,
      kabul:kabul,
      codeControl:codeControl
    },
    data() {
      return {
        headersservis: [{
            text: 'Kod',
            value: 'Kod'
          },
          {
            text: 'Açıklama',
            value: 'ReferansAd',

          }
        ],
        kodmesajı:null,
        progress: false,
        items: [],
        aranacakkelime: null,
        secilendeger: null,
        dialog: false,

        text1: null,
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },

    watch: {
      secilendeger(val) {
        val && this.kayitgetir(val)
      },
       dialog (val2) {
      if (!val2) return
      requestAnimationFrame(() => {
        this.$refs.ara.focus()
      })
    }

    },
  }

function codeControl() {

    if (this.val != null && this.val!='') {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
     var params1 = {
       SirketKodu:credentials.SirketKodu,
       Kod: escape(this.val),
      }
      this.$http.post(auth.API_URL + 'api/Reference/Get', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        if (response.body.length == 1) {
          this.val = response.body[0].Kod
          this.kodmesajı = null
        } else {
          this.kodmesajı = 'Hatalı kod girişi..'
          this.val = null
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-referans'
          this.snackbar = true
          this.progress = false
        } else {
          this.text1 = 'Service Unavailable-referans'
          this.snackbar = true
          this.progress = false
        }
      })
    } else {
      this.kodmesajı = null
    }
  }




  function kabul(m) {
    this.val = m
    this.dialog = false
  }


  function dialogac() {
    this.dialog = true
  }

  function beforeMount() {

  }

  function kayitgetir(y) {

    if (y != null) {

      if (y.length > 2) {

        this.progress = true
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params1 = {
          CompanyCode: credentials.SirketKodu,
          Search: escape(y)
        }
        this.$http.post(auth.API_URL + 'api/Reference/ReferenceSearch', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body

          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Masraf Merkezi'
            this.snackbar = true
            this.progress = false

          } else {
            this.text1 = 'Service Unavailable-Masraf Merkezi'
            this.snackbar = true
            this.progress = false
          }
        })
      } else {
        this.items = []
        this.progress = false
      }

    }
  }
</script>